export default {
  ALL_ORDERS: 'ALL_ORDERS',
  UNPROCESSED: 'UNPROCESSED',
  IN_MANUFACTURING: 'IN_MANUFACTURING',
  IN_INVENTORY: 'IN_INVENTORY',
  ISSUED_TO_PATIENT: 'ISSUED_TO_PATIENT',
} as const
